// extracted by mini-css-extract-plugin
export default {"navbar":"g5_LTeA8","brand":"_2o_n9nwc","brandLogo":"_3Mgl-dra","navRight":"_2l_6U3SV","weekText":"_12rh-nSK"};